import store from '@/store/index.js'
let dic = store.state.dic;
import { getOrgOptions } from "@/libs/searchSelect";
export default function Configs(that) {

    const searchItems = [
        {
            label: "学院",
            span: 6,
            type: 'select',
            model: "collegeId",
            options: dic._COLLEGE_OPTIONS,
            clearable: true,
            change(data) {
                that.searchItems[2].options = [];
                that.searchItems[3].options = [];
                that.pageParams.majorId = "";
                that.pageParams.classIdList = [];
                if (data) {
                    let params = {
                        parentId: data,
                        type: 'department',
                    }
                    getOrgOptions(that, params, 1, null);
                    params = {
                        parentId: data,
                        grade: that.pageParams.grade,
                        type: 'class'
                    }
                    that.searchItems[2].options = [];
                    that.pageParams.classIdList = [];
                    getOrgOptions(that, params, 3, null)
                }
            },
        },
        {
            label: "年级",
            span: 6,
            type: 'year',
            model: "grade",
            clearable: true,
            change(data) {
                that.searchItems[3].options = [];
                let parentId = "";
                if (that.pageParams.classIdList &&that.pageParams.classIdList.size>0) {
                    parentId = that.pageParams.classIdList.join(",");
                } else if (that.pageParams.majorId) {
                    parentId = that.pageParams.majorId;
                } else if (that.pageParams.collegeId) {
                    parentId = that.pageParams.collegeId;
                }
                let params = {
                    parentId: parentId,
                    grade: data,
                    type: 'class'
                }
                that.searchItems[3].options = [];
                that.pageParams.classIdList = [];
                getOrgOptions(that, params, 3, null)
            },
        },
        {
            label: "专业",
            span: 6,
            placeholder: '请选择专业',
            type: 'select',
            model: "majorId",
            clearable: true,
            options: [],
            change(data) {
                that.searchItems[3].options = [];
                that.pageParams.classIdList = [];
                let parentId = "";
                if (data) {
                    parentId = data;
                } else if (that.pageParams.collegeId) {
                    parentId = that.pageParams.collegeId;
                }
                let params = {
                    parentId: parentId,
                    grade: that.pageParams.grade,
                    type: 'class'
                }
                getOrgOptions(that, params, 3, null)
            },
        },
        {
            label: "班级",
            span: 6,
            placeholder: '请选择班级',
            type: 'select',
            model: "classIdList",
            multiple:true,
            clearable: true,
            options: [],
        },
        {
            label: "培养层次",
            span: 6,
            type: 'select',
            options:dic._DEGREE,
            model: "academicDegree",
            clearable: true,
        },
        {
            label: "学制",
            span: 6,
            type: 'select',
            options: dic._ACADEMICYEAR,
            model: "academicYear",
            clearable: true,
        },
        {
            label: "学号/姓名",
            span: 6,
            placeholder: '请输入学号或姓名',
            model: "studentNameOrNo"
        },
        // {
        //     label: "姓名",
        //     span: 6,
        //     placeholder: '请输入姓名',
        //     model: "studentName"
        // },
        {
            label: "性别",
            span: 6,
            type: 'select',
            options: dic._SEXS,
            model: "sex",
            clearable: true,
        },
        {
            label: "身份证号",
            span: 6,
            placeholder: '请输入',
            model: "idCard",
        },
        {
            label: "联系方式",
            span: 6,
            placeholder: '请输入',
            model: "phoneNumber",
        },
        {
            label: "完成情况",
            span: 6,
            placeholder: '请选择',
            model: "status",
            type: "select",
            options: [
                { label: '未测试', value: -1 },
                { label: '未通过', value: 0 },
                { label: '已通过', value: 1 },
            ]
        },
        {
            label: "测试次数",
            span: 6,
            placeholder: '请输入',
            model: "testNum"
        },
        {
            label: "是否手动通过",
            span: 6,
            type: 'select',
            options: dic._IS,
            model: "isTeacherPass",
            labelWidth: '100px',
            clearable: true,
        },
    ]
    const tableColumns = [
        {
            label: "学院",
            prop: "collegeName",
            align: "center",
            show: true,
            minWidth: 180,
        },
        {
            label: "专业",
            prop: "majorName",
            align: "center",
            show: true,
            minWidth: 160,
        },
        {
            label: "班级",
            prop: "className",
            align: "center",
            show: true,
            minWidth: 160,
        },
        {
            label: "学号",
            prop: "studentNo",
            align: "center",
            show: true,
            minWidth: 140,
        },
        {
            label: "姓名",
            prop: "studentName",
            align: "center",
            show: true
        },
        {
            label: "性别",
            prop: "sex",
            align: "center",
            show: true
        },
        {
            label: "培养层次",
            prop: "academicDegreeName",
            align: "center",
            show: true
        },
        {
            label: "完成情况",
            name: "status",
            align: "center",
            show: true,
            minWidth: 180,
        },
        {
            label: "测试次数",
            prop: "testNum",
            align: "center",
            show: true,
            minWidth: 100,
        },
        {
            label: "最终得分",
            prop: "score",
            align: "center",
            show: true,
            minWidth: 100,
        },
        {
            label: "操作",
            name: "custom",
            align: "center",
            width: '120px',
            show: true
        }
    ]
    const formItems = [
        {
            label: "姓名",
            span: 24,
            model: "studentName",
            placeholder: '请输入站点名称',
            labelClass: 'info-label',
        },
        {
            label: "学号",
            span: 24,
            model: "studentNo",
            labelClass: 'info-label',
            placeholder: '请输入说明',
        },
        {
            label: "学院",
            span: 24,
            model: "collegeName",
            labelClass: 'info-label',
            placeholder: '请输入说明',
        },
        {
            label: "专业",
            span: 24,
            model: "majorName",
            labelClass: 'info-label',
            placeholder: '请输入说明',
        },
        {
            label: "班级",
            span: 24,
            model: "className",
            labelClass: 'info-label',
            placeholder: '请输入说明',
        },
        {
            label: "完成情况",
            span: 24,
            model: "description",
            labelClass: 'info-label',
            placeholder: '请输入说明',
        },
    ]

    const formRules = {
        location: [{
            required: true,
            trigger: "blur",
            message: '请输入站点名称'
        }],
        description: [{
            required: true,
            trigger: "blur",
            message: '请输入说明'
        }],
    }
    return {
        searchItems,
        tableColumns,
        formItems,
        formRules
    }
}
